"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalLayout = require("./ModalLayout");
Object.keys(_ModalLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalLayout[key];
    }
  });
});